import { useContext } from 'react';
import { AuthContext } from '@/hooks/AuthProvider'; // ou caminho absoluto correto
import type { AuthContextType } from '@/hooks/AuthProvider';

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};
